import Vue from 'vue';
import es from 'vee-validate/dist/locale/es';
import validation_es from '../languages/es/validation_es';
import VeeValidate, { Validator } from 'vee-validate';
Vue.use(VeeValidate);

// We merge
const dictionary = {
  messages: { ...es.messages, ...validation_es.messages },
  attributes: { ...validation_es.attributes },
};

Validator.localize('es', { ...es, ...dictionary });
